import React, { useState } from 'react';

export default function SwitchButton({ checked, onChange, label }) {
  const [isOn, setIsOn] = useState(checked || false);

  const handleToggle = () => {
    setIsOn(!isOn);
    if (onChange) onChange(!isOn);
  };

  return (
    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
      <input
        type="checkbox"
        checked={isOn}
        onChange={handleToggle}
        style={{ display: 'none' }}
      />
      <span
        style={{
          width: 50,
          height: 30,
          background: isOn ? '#4caf50' : '#ccc',
          borderRadius: 20,
          position: 'relative',
          transition: 'background 0.2s',
        }}
      >
        <span
          style={{
            position: 'absolute',
            left: isOn ? 22 : 2,
            top: 2,
            width: 26,
            height: 26,
            background: '#fff',
            borderRadius: '50%',
            transition: 'left 0.2s',
          }}
        />
      </span>
    </label>
  );
}